<template>
  <h3 class="heading-3 mb-16">
    {{ i18n(translations.title, { email }) }}
  </h3>

  <RevCard class="mb-32 p-24">
    <RevIllustration
      :alt="i18n(translations.bouyguesIcon)"
      class="mb-8"
      :height="24"
      src="/img/bouygues/bouyguesLogoSquare.svg"
      :width="24"
    />

    <div class="mb-24">{{ i18n(translations.loginInformation) }}</div>
    <RevButton :to="authorizeUrl.href" variant="primary">
      {{ i18n(translations.login) }}
    </RevButton>
  </RevCard>

  <RevLink @click="() => emit('sign-up-link-clicked')">
    {{ i18n(translations.signUpLink) }}
  </RevLink>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import { useBouyguesAuthorize } from '../../../../composables/useBouyguesAuthorize'

import translations from './LoginForm.translations'

const { authorizeUrl } = useBouyguesAuthorize()
const i18n = useI18n()

defineProps<{
  email: string
}>()

const emit = defineEmits(['sign-up-link-clicked'])
</script>
